<div class="plan-header-section">
  <span *ngIf="planHeaderBannerLanguage" data-test="yearly-savings-desktop-percent">{{ planHeaderBannerLanguage }}</span>
</div>

<div
  class="plan-selection-card d-none d-md-block"
  data-test="plan-selection-card-desktop"
  [ngClass]="{
    selected: plan.id === selectedPlan.id,
    'is-single-plan': hasOneShownPlan
  }"
  (click)="changeSelectedPlan(plan)"
>
  <div class="plan-selection-section">
    <div class="inner-wrapper">
      <h3 class="plan-title" data-test="plan-title-desktop">
        {{ planTitle }}
      </h3>
        <h3
          class="plan-cost funnel-title d-flex align-items-baseline"
          data-test="plan-cost-desktop"
          [ngClass]="{'mobile-small-font': periodCostLanguage?.length > 7}">
          {{ periodCostLanguage }}<span class="d-flex flex-column per-period justify-content-center ms-1 subhead">
          <span>/{{plan.yearly | floPricePeriod: plan.display_price_annually}}</span></span>
        </h3>
      <p class="font-size-2">{{ billedAsLanguage }}</p>
      <label
        class="control-radio primary-color-radio"
        [ngClass]="
          plan?.period + '-' + plan?.cost_per_month?.amount?.toString()
        "
      >
        <input *ngIf="hasOneShownPlan" type="hidden" value="plan" />
        <input
          *ngIf="!hasOneShownPlan"
          type="radio"
          class="plans"
          [checked]="plan?.id === selectedPlan?.id"
          [value]="plan"
          (click)="$event.stopPropagation()"
        />
        <div
          *ngIf="!hasOneShownPlan"
          class="control-radio-overlay primary-overlay"
        ></div>
      </label>
      <p *ngIf="desktopRadioSubHeading" class=""><small>{{ desktopRadioSubHeading }}</small></p>
    </div>
  </div>
  <div class="plan-props-section">
    <flo-value-prop
      *ngIf="!hasOneShownPlan && plan.yearly && savingsText"
      label="checkmark-green"
      [proposition]="savingsText"
      svgWidth="18"
    ></flo-value-prop>
    <flo-value-prop label="checkmark-green" [proposition]="billedAsFunnelText" svgWidth="18"></flo-value-prop>
    <flo-value-prop
      *ngFor="let valueProp of valueProps;"
      [proposition]="valueProp"
      label="checkmark-green"
      svgWidth="18"
    ></flo-value-prop>
  </div>
</div>

<!-- Mobile view for plan selection -->
<div
  class="plan-selection-card d-md-none"
  [ngClass]="{
    selected: plan.id === selectedPlan.id,
    'is-single-plan': hasOneShownPlan
  }"
  (click)="changeSelectedPlan(plan)"
>
  <div class="plan-selection-section">
    <div class="inner-wrapper">
      <h3 class="plan-title" data-test="plan-title-mobile">
        {{ planTitle }}
      </h3>
        <h3
          class="plan-cost funnel-title d-flex align-items-baseline"
          [ngClass]="{'mobile-small-font': periodCostLanguage?.length > 7}"
          data-test="plan-cost-mobile">
          {{ periodCostLanguage }}<span class="d-flex flex-column per-period justify-content-center ms-1 subhead">
          <span>/{{
          plan.yearly | floPricePeriod: plan.display_price_annually
            }}</span></span>
        </h3>
      <p class="font-size-2">{{ billedAsLanguage }}</p>
      <label
        class="control-radio primary-color-radio"
        [ngClass]="
          plan?.period + '-' + plan?.cost_per_month?.amount?.toString()
        "
      >
        <input *ngIf="hasOneShownPlan" type="hidden" value="plan" />
        <input
          *ngIf="!hasOneShownPlan"
          type="radio"
          class="plans"
          [checked]="plan.id === selectedPlan.id"
          [value]="plan"
          (click)="$event.stopPropagation()"
        />
        <div
          *ngIf="!hasOneShownPlan"
          class="control-radio-overlay primary-overlay"
        ></div>
      </label>
      <p *ngIf="mobileRadioSubHeading" class="mt-1"><small>{{ mobileRadioSubHeading }}</small></p>
    </div>
  </div>
</div>
